import { token } from "./token.js";
import { makeInternalTokens } from "./makeInternalTokens.js";
const {
  internalTokens,
  declareTokens
} = makeInternalTokens({
  lightTheme: {
    "toolbar-background-color": token.white
  },
  darkTheme: {
    "toolbar-background-color": token.gray25
  }
});
export {
  declareTokens,
  internalTokens
};
//# sourceMappingURL=themes2.js.map
